import React, { forwardRef } from "react";

interface SubmitButtonProps {
	isFetching?: boolean;
	disabled?: boolean;
	onClick?: () => void;
	className?: string;
	"data-testid"?: string;
	"data-automationid"?: string;
	children: string | React.ReactNode;
}

export const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
	(props, ref) => {
		const {
			isFetching,
			disabled,
			onClick,
			className,
			"data-testid": dataTestId,
			"data-automationid": dataAutomationId,
			children,
		} = props;
		return (
			<div className={className}>
				<button
					type="submit"
					className="button primary"
					data-automationid={dataAutomationId || "login.submit"}
					data-testid={dataTestId || "submit-button"}
					disabled={isFetching || disabled}
					onClick={onClick}
					ref={ref}
				>
					{children}
				</button>
			</div>
		);
	},
);
